import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_5 = { style: {"width":"200px"} }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = {
  class: "shadow-none lh-1 fw-medium text-black-emphasis",
  style: {"max-width":"300px","word-wrap":"break-word","white-space":"normal"}
}
const _hoisted_14 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }
const _hoisted_23 = {
  class: "modal fade",
  id: "detailsMagasinModal",
  tabindex: "-1",
  "aria-labelledby": "detailsMagasinModalLabel",
  "aria-hidden": "true"
}
const _hoisted_24 = { class: "modal-dialog modal-lg" }
const _hoisted_25 = { class: "modal-content" }
const _hoisted_26 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "text-muted" }
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "mb-3" }
const _hoisted_37 = { class: "text-muted" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "text-muted" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "col-12" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "text-muted" }
const _hoisted_45 = {
  key: 0,
  class: "row"
}
const _hoisted_46 = { class: "col-12" }
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "mt-2" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!
  const _component_AddMagasinModal = _resolveComponent("AddMagasinModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.checkPermission('AddMagasin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                class: "btn btn-primary ms-3",
                to: { name: 'AddMagasin' }
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                  _createTextVNode(" Ajouter un magasin ")
                ])),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.point_ventes.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Filtrer par Point de vente", -1)),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.point_ventes.length > 1)
                  ? (_openBlock(), _createBlock(_component_Multiselect, {
                      key: 0,
                      modelValue: _ctx.point_vente,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.point_vente) = $event)),
                      options: _ctx.point_ventes,
                      searchable: true,
                      "track-by": "label",
                      label: "label",
                      placeholder: "Sélectionner un point de vente"
                    }, null, 8, ["modelValue", "options"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("form", {
            class: "search-bg svg-color pt-3 d-flex align-items-center",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
              class: "form-control shadow-none text-black mx-2 flex-grow-1",
              placeholder: "Rechercher un magasin"
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Code "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Nom Mag. "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Magasinier "),
                _createElementVNode("th", {
                  scope: "col",
                  style: {"max-width":"300px","word-wrap":"break-word","white-space":"normal"},
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                }, " Adresse "),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
                }, " ACTIONS ")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.magasins, (magasin, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_10, _toDisplayString(magasin.code), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(magasin.nomMagasin), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(magasin?.user?.nom) + " " + _toDisplayString(magasin?.user?.prenom), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(magasin.adresse), 1),
                  _createElementVNode("td", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[11] || (_cache[11] = _createElementVNode("button", {
                        class: "btn dropdown-toggle btn-primary",
                        type: "button",
                        "data-bs-toggle": "dropdown",
                        "aria-expanded": "false"
                      }, "Actions", -1)),
                      _createElementVNode("ul", _hoisted_16, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            class: "dropdown-item d-flex align-items-center",
                            href: "javascript:void(0);",
                            onClick: ($event: any) => (_ctx.voirDetails(magasin)),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#detailsMagasinModal"
                          }, _cache[8] || (_cache[8] = [
                            _createElementVNode("i", { class: "fa fa-eye lh-1 me-8 position-relative top-1" }, null, -1),
                            _createTextVNode(" Voir détails ")
                          ]), 8, _hoisted_17)
                        ]),
                        (_ctx.checkPermission('EditMagasin'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.navigateToEdit(magasin.id))
                              }, _cache[9] || (_cache[9] = [
                                _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Modifier ")
                              ]), 8, _hoisted_19)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.checkPermission('DeleteMagasin'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_20, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (_ctx.suppression(magasin.id, _ctx.magasins, 'magasins', `le magasin ${magasin.nomMagasin}`))
                              }, _cache[10] || (_cache[10] = [
                                _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1),
                                _createTextVNode(" Supprimer ")
                              ]), 8, _hoisted_21)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createVNode(_component_AddMagasinModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger
    }, null, 8, ["item", "onClose"]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", {
              class: "modal-title",
              id: "detailsMagasinModalLabel"
            }, "Détails du Magasin"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          (_ctx.magasinSelectionne)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Code:", -1)),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.magasinSelectionne.code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _cache[14] || (_cache[14] = _createElementVNode("strong", null, "Nom du Magasin:", -1)),
                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.magasinSelectionne.nomMagasin), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Magasinier:", -1)),
                      _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.magasinSelectionne.user?.nom) + " " + _toDisplayString(_ctx.magasinSelectionne.user?.prenom), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[16] || (_cache[16] = _createElementVNode("strong", null, "Magasin Principal:", -1)),
                      _createElementVNode("p", _hoisted_40, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.magasinSelectionne.estPrincipal ? 'bg-success' : 'bg-secondary'])
                        }, _toDisplayString(_ctx.magasinSelectionne.estPrincipal ? 'Oui' : 'Non'), 3)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, [
                      _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Adresse:", -1)),
                      _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.magasinSelectionne.adresse || 'Non renseignée'), 1)
                    ])
                  ])
                ]),
                (_ctx.magasinSelectionne.photo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          _cache[18] || (_cache[18] = _createElementVNode("strong", null, "Photo:", -1)),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("img", {
                              src: _ctx.magasinSelectionne.photo,
                              alt: "Photo du magasin",
                              class: "img-thumbnail",
                              style: {"max-width":"200px","max-height":"200px"}
                            }, null, 8, _hoisted_49)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_50, [
            _cache[19] || (_cache[19] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Fermer", -1)),
            (_ctx.checkPermission('EditMagasin'))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateToEdit(_ctx.magasinSelectionne.id))),
                  "data-bs-dismiss": "modal"
                }, " Modifier "))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}